import ReactDOM from "react-dom/client";

import "./theme.css";

import { App } from "./app";

// Проверка вёрстки под крупный системный шрифт без эмулятора: `?fontScale=1.5` в dev.
if (import.meta.env.DEV) {
  const scale = Number(new URLSearchParams(window.location.search).get("fontScale"));
  if (scale > 0) document.documentElement.style.fontSize = `${scale * 100}%`;
}

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
